import { getFieldParser, multi_converters, number_or_0, physical_converters, string_or_empty, } from '../../utils/parser-utils';
import { ObjectLine } from 'z3k-parser/parser/utils/object-line';
export const threeway_taps_fields = [
    { name: 'name', ...string_or_empty },
    {
        name: 'physical_output1',
        ...physical_converters,
    },
    {
        name: 'physical_output2',
        ...physical_converters,
    },
    { name: 'step_time', ...multi_converters(1000) },
    { name: 'closing_time', ...multi_converters(1000) },
    { name: 'coefficient', ...multi_converters(1000) },
    { name: 'setting_register', ...number_or_0 },
    {
        name: 'step_period',
        ...number_or_0,
        ...multi_converters(1000),
        default_from_op: 10000,
    },
];
const { fromStr } = getFieldParser(threeway_taps_fields);
function threewayTaps2Str(obj_id, obj) {
    return new ObjectLine(obj.id, obj_id, [
        obj.name,
        obj.physical_output1 === -1 ? 255 : obj.physical_output1,
        obj.physical_output2 === -1 ? 255 : obj.physical_output2,
        Math.round(obj.step_time * 1000),
        Math.round(obj.closing_time * 1000),
        Math.round((obj.coefficient || 0) * 1000),
        obj.setting_register || 0,
        ((obj.setting_register || 0) & 0x1) == 0
            ? Math.round(obj.step_period || 10) * 1000
            : 10000,
        ...(obj.rest || []),
    ]);
}
export const threeway_taps_parser = {
    toStr: threewayTaps2Str,
    fromStr: fromStr,
};
